import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import TextAreaInput from '../common/TextAreaInput';
var ContactFormModal = /*#__PURE__*/function (_PureComponent) {
  function ContactFormModal() {
    var _this;
    _classCallCheck(this, ContactFormModal);
    _this = _callSuper(this, ContactFormModal);
    _this.state = {
      sending: false,
      sent: false,
      error: '',
      message: ''
    };
    _this.handleMessageValue = _this.handleMessageValue.bind(_this);
    _this.handleSendMessage = _this.handleSendMessage.bind(_this);
    return _this;
  }
  _inherits(ContactFormModal, _PureComponent);
  return _createClass(ContactFormModal, [{
    key: "handleMessageValue",
    value: function handleMessageValue(message) {
      this.setState({
        message: message
      });
    }
  }, {
    key: "handleSendMessage",
    value: function handleSendMessage() {
      var _this2 = this;
      var csrfToken = this.props.csrfToken;
      var _this$state = this.state,
        error = _this$state.error,
        message = _this$state.message;
      this.setState({
        sending: true
      });
      if (!message) {
        this.setState({
          error: 'Please make sure you write a message before submitting.',
          sending: false
        });
        return;
      }
      postRequest('projects/project_lead', {
        contact_message: message
      }, csrfToken).then(function () {
        if (error) _this2.setState({
          error: ''
        });
        _this2.setState({
          sending: false,
          sent: true,
          message: ''
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state2 = this.state,
        sent = _this$state2.sent,
        sending = _this$state2.sending,
        message = _this$state2.message,
        error = _this$state2.error;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Contact Sales",
        buttonStyles: "link btn-sales",
        submitButtonText: "Send Message",
        cancelButton: false,
        showFooter: false,
        triggerType: "button",
        onCloseCallback: function onCloseCallback() {
          if (sent) _this3.setState({
            sent: false
          });
        },
        idKey: "contact-support-modal"
      }, sent ? /*#__PURE__*/React.createElement("div", {
        className: "contact-success-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "contact-header"
      }, "Message sent!"), /*#__PURE__*/React.createElement("p", {
        className: "contact-secondary"
      }, "Clora will contact you shortly to assist with this need.")) : /*#__PURE__*/React.createElement("div", {
        className: "contact-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "contact-header"
      }, "Contact Sales"), /*#__PURE__*/React.createElement("p", {
        className: "contact-secondary"
      }, "How can we help? Describe your need and its context."), error && /*#__PURE__*/React.createElement("div", {
        className: "error"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-exclamation-triangle"
      }), /*#__PURE__*/React.createElement("span", null, error)), /*#__PURE__*/React.createElement(TextAreaInput, {
        className: "form-control fs-hide",
        textAreaPrompt: "",
        placeholder: "",
        rows: 3,
        value: message,
        onAnswerChange: function onAnswerChange(val) {
          return _this3.handleMessageValue(val);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "contact-footer"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        onClick: this.handleSendMessage,
        disabled: sending,
        block: true
      }, sending ? 'Sending...' : 'Send Message'))));
    }
  }]);
}(PureComponent);
ContactFormModal.propTypes = {
  csrfToken: PropTypes.string
};
ContactFormModal.defaultProps = {
  csrfToken: ''
};
export default ContactFormModal;